// extracted by mini-css-extract-plugin
module.exports = {"SkipToMainContent":"kENB6-"};